"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createState = void 0;
const core_1 = require("../core");
const store_1 = require("./store");
const createState = (state, reducers) => {
    const store = (0, core_1.provide)(store_1.Store);
    store.init(state, reducers);
    return store;
};
exports.createState = createState;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvcGFja2FnZXMvc3RvcmUvc3RhdGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsa0NBQWtDO0FBQ2xDLG1DQUE2QztBQUV0QyxNQUFNLFdBQVcsR0FBRyxDQUN6QixLQUFRLEVBQ1IsUUFBd0IsRUFDZCxFQUFFO0lBQ1osTUFBTSxLQUFLLEdBQUcsSUFBQSxjQUFPLEVBQVcsYUFBSyxDQUFDLENBQUM7SUFFdkMsS0FBSyxDQUFDLElBQUksQ0FBQyxLQUFLLEVBQUUsUUFBUSxDQUFDLENBQUM7SUFFNUIsT0FBTyxLQUFLLENBQUM7QUFDZixDQUFDLENBQUM7QUFUVyxRQUFBLFdBQVcsZUFTdEIifQ==